var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSolana = function SvgSolana(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.199,
    cy: 12.733,
    r: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.27 8.772a.604.604 0 0 1-.243.051H4.506a.304.304 0 0 1-.281-.186.315.315 0 0 1 .056-.336l2.638-2.87a.611.611 0 0 1 .447-.198h12.521a.303.303 0 0 1 .286.184.312.312 0 0 1-.058.339l-2.641 2.87a.61.61 0 0 1-.203.146Zm.204 2.113a.617.617 0 0 0-.447-.198H4.506a.304.304 0 0 0-.281.187.315.315 0 0 0 .056.336l2.638 2.871a.617.617 0 0 0 .447.198h12.521a.304.304 0 0 0 .28-.187.314.314 0 0 0-.056-.336l-2.637-2.871Zm2.641 5.78-2.641 2.87a.611.611 0 0 1-.447.198H4.506a.304.304 0 0 1-.281-.187.315.315 0 0 1 .056-.336l2.638-2.87a.613.613 0 0 1 .447-.197h12.521a.303.303 0 0 1 .286.184.313.313 0 0 1-.058.338Z",
    fill: "#000"
  })));
};

export default SvgSolana;